module.exports = __webpack_public_path__ + "static/media/screen4.84183150.png";